import { createFileRoute, redirect } from "@tanstack/react-router";
import { REGISTRATION_TITLE, REGISTRATION_MEETING_SLUG } from "@/lib/event-registration";

export const Route = createFileRoute("/b-2026-11-04")({
  staticData: { sitemap: false },
  beforeLoad: () => {
    throw redirect({ to: "/meetings/$slug", params: { slug: REGISTRATION_MEETING_SLUG }, replace: true, statusCode: 301 });
  },
  head: () => ({ meta: [
    { title: `${REGISTRATION_TITLE} — Registration — Foreign Council` },
    { name: "description", content: `Event registration for the ${REGISTRATION_TITLE}.` },
    { property: "og:title", content: `${REGISTRATION_TITLE} — Registration` },
    { property: "og:description", content: `Event registration for the ${REGISTRATION_TITLE}.` },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "robots", content: "noindex, nofollow" },
  ] }),
});
